import { LoggedInState, LoggedOutState, LoginFailedState, LoginStateInterface, } from './login.state';
import {
    LOGIN_DO_FORCE_LOGOUT, LOGIN_DO_LOGOUT, LOGIN_FAILED, LOGIN_REFRESH_JWT, LOGIN_SUCCESS, LOGIN_TAN_SESSION_RESET, LoginActionInterface,
    LoginRefreshJWTAction
} from './login.action';


export function loginReducer(state: LoginStateInterface = new LoggedOutState(), action: LoginActionInterface): LoginStateInterface {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return new LoggedInState(action.jwt, action.tan || null);
        case LOGIN_FAILED:
            return new LoginFailedState(action.error);
        case LOGIN_DO_LOGOUT:
        case LOGIN_DO_FORCE_LOGOUT:
        case LOGIN_TAN_SESSION_RESET:
            return new LoggedOutState();
        case LOGIN_REFRESH_JWT:
            return state.loggedIn ? {...state, jwt: (<LoginRefreshJWTAction>action).jwt} : state;
        default:
            return state;
    }
}
